"use strict";
var ringSizes = [
        // { 14: { us: "3", uk: "F" } },
        // { 14.4: { us: "3.5", uk: "G" } },
        // { 14.8: { us: "4", uk: "H" } },
        // { 15.2: { us: "4.5", uk: "I" } },
        // { 15.6: { us: "5", uk: "J" } },
        // { 16: { us: "5.5", uk: "K" } },
        // { 16.45: { us: "6", uk: "L" } },
        // { 16.9: { us: "6.5", uk: "M" } },
        // { 17.3: { us: "7", uk: "N" } },
        // { 17.7: { us: "7.5", uk: "O" } },
        // { 18.2: { us: "8", uk: "P" } },
        // { 18.6: { us: "8.5", uk: "Q" } },
        // { 19: { us: "9", uk: "R" } },
        // { 19.4: { us: "9.5", uk: "S" } },
        // { 19.8: { us: "10", uk: "T" } },
        // { 20.2: { us: "10.5", uk: "U" } },
        // { 20.6: { us: "11", uk: "V" } },
        // { 21: { us: "11.5", uk: "W" } },
        // { 21.44: { us: "12", uk: "X" } },

        { 14.5: { us: "3.75mm", uk: "G" } },
        { 14.8: { us: "4.25mm", uk: "H" } },
        { 15.2: { us: "4.5mm", uk: "I" } },
        { 15.6: { us: "5.0mm", uk: "J" } },
        { 16.0: { us: "5.5mm", uk: "K" } },
        { 16.4: { us: "6.0mm", uk: "L" } },
        { 16.8: { us: "6.5mm", uk: "M" } },
        { 17.2: { us: "6.75mm", uk: "N" } },
        { 17.4: { us: "7.0mm", uk: "O" } },
        { 18.0: { us: "7.5mm", uk: "P" } },
        { 18.4: { us: "8.0mm", uk: "Q" } },
        { 19.0: { us: "8.5mm", uk: "R" } },
        { 19.2: { us: "9.0mm", uk: "S" } },
        { 19.5: { us: "9.5mm", uk: "T" } },
        { 20.0: { us: "10.0mm", uk: "U" } },
        { 20.3: { us: "10.5mm", uk: "V" } },
        { 20.7: { us: "11.0mm", uk: "W" } },
        { 21.1: { us: "11.5mm", uk: "X" } },
        { 21.4: { us: "12.0mm", uk: "Y" } },
        { 21.8: { us: "12.5mm", uk: "Z" } },
    ],
    pixelsToMmRatio = 6.00;
function setCookie(t, e, n) {
    var o = new Date(),
        n = (o.setTime(o.getTime() + 24 * n * 60 * 60 * 1e3), "expires=" + o.toUTCString());
    document.cookie = t + "=" + e + ";" + n + ";path=/";
}
function incrementSlider(t, e) {
    var n = t.parentElement,
        o = n.parentElement.parentElement.parentElement.querySelector(".scalable"),
        e = t.offsetLeft + e,
        i = e + t.offsetWidth > n.offsetWidth;
    e < 0 ||
        i ||
        ((t.style.left = "".concat(e, "px")),
        (i = ((t.getBoundingClientRect().right - t.offsetWidth / 2 - n.getBoundingClientRect().left) / n.offsetWidth) * (1.3 - 0.7) + 0.7),
        o.classList.contains("card")
            ? ((o.style.transform = "scale(".concat(i, ")")), (e = o.getBoundingClientRect().bottom - o.getBoundingClientRect().top), (pixelsToMmRatio = e / 54))
            : (moveRing(0, 0, i),
              (t = ((o.getBoundingClientRect().bottom - o.getBoundingClientRect().top) / pixelsToMmRatio).toFixed(2)),
              (document.getElementById("actual-height").textContent = "".concat(t, "mm")),
              (n = outputRingSize(t)),
               (document.getElementById("selected_size").textContent = "Your size is ".concat(n.uk)),
              (document.getElementById("ring-size-output--uk").textContent = "UK Size ".concat(n.uk)),
              (document.getElementById("ring-size-output--us").textContent = "US Size ".concat(n.us))),
        document.querySelectorAll('tr[data-size]').forEach(function(tr) {
                  if (tr.getAttribute('data-size') === n.us) {
                      tr.classList.add('active');
                    // Get the text of the first <td> element
                    var firstTdText = tr.querySelector('td').textContent;
                     document.getElementById("Inside_Diameter").textContent = "".concat(firstTdText);
                    
                  } else {
                      tr.classList.remove('active');
                  }
              }));
  document.querySelector(".ring-size-next").addEventListener("click", function () {
        var t = document.querySelector(".ring-size"),
            e = document.getElementById("ring_size_tabel");
        (t.style.display = "none"), (e.style.display = "block");
          var activeRow = document.querySelector('tr.active');
            if (activeRow) {
                activeRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

        document.querySelectorAll('tr[data-size]').forEach(function(tr) {
            if (tr.getAttribute('data-size') === n.us) {

                // Scroll to the active <tr> element
                tr.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        })
    })
}
document.querySelector("#ring-size .ring").style.transform = "translateX(0px) translateY(0px) scale(1)";
var controlSliderTouch = function (o) {
        var i,
            c,
            s = o.parentElement,
            l = s.parentElement.parentElement.parentElement.querySelector(".scalable");
        (s.ontouchmove = function (t) {
            for (var e, n = window.setTimeout(function () {}, 0); n--; ) window.clearTimeout(n);
            (i = t.targetTouches[0].clientX - s.getBoundingClientRect().left - o.offsetWidth / 2 < -10),
                (c = 10 < t.targetTouches[0].clientX + o.offsetWidth - s.getBoundingClientRect().right - o.offsetWidth / 2),
                i ||
                    c ||
                    ((e = ((t.targetTouches[0].clientX - s.getBoundingClientRect().left) / s.offsetWidth) * (1.3 - 0.7) + 0.7),
                    (o.style.left = "".concat(t.targetTouches[0].clientX - s.getBoundingClientRect().left - o.offsetWidth / 2, "px")),
                    l.classList.contains("card")
                        ? ((l.style.transform = "scale(".concat(e, ")")), (t = l.getBoundingClientRect().bottom - l.getBoundingClientRect().top), (pixelsToMmRatio = t / 54))
                        : (moveRing(0, 0, e),
                          (t = ((l.getBoundingClientRect().bottom - l.getBoundingClientRect().top) / pixelsToMmRatio).toFixed(2)),
                          (document.getElementById("actual-height").textContent = "".concat(t, "mm")),
                          (e = outputRingSize(t)),
                           (document.getElementById("selected_size").textContent = "Your size is ".concat(e.uk)),
                          (document.getElementById("ring-size-output--uk").textContent = "UK Size ".concat(e.uk))),
                          document.querySelectorAll('tr[data-size]').forEach(function(tr) {
                            if (tr.getAttribute('data-size') === e.us) {
                                tr.classList.add('active');
                               var firstTdText = tr.querySelector('td').textContent;
                               document.getElementById("Inside_Diameter").textContent = "".concat(firstTdText)
                            } else {
                                tr.classList.remove('active');
                            }
                        }));
        }),
            (s.ontouchend = function () {
                setCookie("crs-pxmm", pixelsToMmRatio, 360);
            });
    },
    allSliders = Array.from(document.querySelectorAll(".slider"));
function outputRingSize(t) {
    for (var e, n = 0; n < ringSizes.length; n++) {
        var o = Object.keys(ringSizes[n])[0];
        parseFloat(t) >= parseFloat(o) && (e = ringSizes[n][o]);
    }
    return e || ringSizes[0][14];
}
function moveRing(t, e, n) {
    var o = document.querySelector("#ring-size .ring"),
        i = o.parentElement.getBoundingClientRect(),
        c = o.style.transform.split("translateX(")[1],
        c = parseInt(c.split("px)")[0]),
        s = o.style.transform.split("translateY(")[1],
        s = parseInt(s.split("px)")[0]),
        l = o.style.transform.split("scale(")[1],
        l = parseFloat(l.split("px)")[0]),
        t = "translateX("
            .concat(c + t, "px) translateY(")
            .concat(s + e, "px) scale(")
            .concat(n || l, ")"),
        e = ((o.style.transform = t), o.getBoundingClientRect()),
        n = document.querySelector(".ring-pos").offsetHeight,
        t = e.top > i.top + n,
        r = e.right < i.right - n,
        u = e.bottom < i.bottom - n,
        e = e.left > i.left + n;
    (t && e && u && r) || ((i = "translateX(".concat(c, "px) translateY(").concat(s, "px) scale(").concat(l, ")")), (o.style.transform = i));
}
function changeRingPos() {
    Array.from(document.querySelectorAll(".ring-pos")).forEach(function (t) {
        t.addEventListener("click", function () {
            t.classList.contains("ring-pos--up") && moveRing(0, -1),
                t.classList.contains("ring-pos--right") && moveRing(1, 0),
                t.classList.contains("ring-pos--down") && moveRing(0, 1),
                t.classList.contains("ring-pos--left") && moveRing(-1, 0);
        });
    });
}
allSliders.forEach(function (t) {
    var e = t.querySelector(".slider__handle"),
        n = t.querySelector(".slider__control--increase"),
        t = t.querySelector(".slider__control--decrease");
    controlSliderTouch(e),
        n.addEventListener("click", function () {
            incrementSlider(e, 2);
        }),
        t.addEventListener("click", function () {
            incrementSlider(e, -2);
        });
}),
    document.querySelector(".start").addEventListener("click", function () {
        document.querySelector(".ring-sizer-introduction").style.display = "none";
    }),
    document.querySelector(".next").addEventListener("click", function () {
      $('.slider__control--decrease').trigger('click');
        var t = document.getElementById("calibration"),
            e = document.getElementById("ring-size");
        (t.style.display = "none"), (e.style.display = "block");
    }),
    document.querySelector(".back").addEventListener("click", function () {
        var t = document.getElementById("calibration"),
            e = document.getElementById("ring-size");
        (t.style.display = "block"), (e.style.display = "none");
    }),
    document.querySelector("#ring_size_tabel .back").addEventListener("click", function () {
        var t = document.querySelector(".ring-size"),
            e = document.getElementById("ring_size_tabel");
        (t.style.display = "block"), (e.style.display = "none");
    }),
    changeRingPos();
//# sourceMappingURL=global.js.map
